import { Box, TextField, Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { SxProps, Theme } from "@mui/material/styles";
import {minWidth} from "@mui/system";

type ConfirmTextFieldProps = {
    label: string;
    value: string;
    onChange: (value: string) => void;
    onConfirm: () => void;
    buttonText?: string;
    buttonSx?: SxProps<Theme>;
    disableTextField?: boolean;
    disableButton?: boolean;
};

export default function ConfirmTextField({
                                             label,
                                             value,
                                             onChange,
                                             onConfirm,
                                             buttonText = "Confirm",
                                             buttonSx,
    disableTextField = false,
    disableButton = false,
                                         }: ConfirmTextFieldProps) {
    return (
        <Box display="flex" alignItems="center" gap={1}>
            <TextField
                data-tour={"content-aggregation-save-button-confirm-text"}
                disabled={disableTextField}
                label={label}
                value={value}
                sx={{minWidth: 325}}
                onChange={(e) => onChange(e.target.value)}
            />

            <Button
                data-tour={"content-aggregation-save-button-confirm"}
                variant="contained"
                startIcon={<CheckIcon />}
                onClick={onConfirm}
                sx={buttonSx}
                disabled={disableButton}
            >
                {buttonText}
            </Button>
        </Box>
    );
}